import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

const EMPTY = { full_name: "", phone: "", country: "", password: "", confirm: "" };

const validate = (form, photo, pkg, t) => {
  if (!form.full_name || !form.phone || !form.country || !form.password) return t("err_required");
  if (!photo) return t("err_photo");
  if (!pkg) return t("err_package");
  if (form.password !== form.confirm) return t("err_password_match");
  return "";
};

const toFormData = (form, pkg, photo) => {
  const fd = new FormData();
  ["full_name", "phone", "country", "password"].forEach((k) => fd.append(k, form[k]));
  fd.append("package_id", pkg);
  fd.append("id_photo", photo);
  return fd;
};

export const useRegisterForm = (t, initialPkg) => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState(EMPTY);
  const [pkg, setPkg] = useState(initialPkg || "");
  const [photo, setPhoto] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    const err = validate(form, photo, pkg, t);
    setError(err);
    if (err) return;
    setBusy(true);
    try {
      await register(toFormData(form, pkg, photo));
      toast.success(t("registered_ok"));
      navigate("/dashboard");
    } catch (ex) {
      setError(formatApiError(ex));
    } finally {
      setBusy(false);
    }
  };

  return { form, setField, pkg, setPkg, photo, setPhoto, error, busy, submit };
};
